<div class="card" [attr.data-automation-id]="'gc-chat-message-card'">
  <img *ngIf="card.image" [src]="card.image" [attr.data-automation-id]="'gc-chat-message-card-image'" />
  <app-genesys-iframe
    *ngIf="!card.image && card.video"
    [iframeUrl]="card.video"
    [attr.data-automation-id]="'gc-chat-message-card-video'"
  ></app-genesys-iframe>
  <div class="body">
    <div class="title" [title]="card.title" [attr.data-automation-id]="'gc-chat-message-card-title'">{{ card.title }}</div>
    <div class="description" [attr.data-automation-id]="'gc-chat-message-card-description'">{{ card.description }}</div>
    <button
      disabled
      class="btn"
      [attr.data-automation-id]="'gc-chat-message-card-button'"
      [title]="button.text"
      *ngFor="let button of card.actions"
    >
      <span>{{ button.text }}</span>
    </button>
  </div>
</div>
